/*
 * GruppenCard.tsx
 *
 * Created by Dr. Maximillian Dornseif 2022-03-03 in huWaWi3 26.0.3
 * Copyright (c) 2022 HUDORA GmbH
 */

import { LinkRender } from '../hd-link'
import { LadeChecker } from '@hudora/hd-react-components'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import gql from 'graphql-tag'
import { useQuery } from 'urql'

import { GRUPPE_FRAGMENT } from '../../fragments'

interface GruppenCardProps {
  /** Kundennummer. Wenn leer oder kein Kunde gefunden, wird auch nichts angezeigt.
   * */
  nr: string
}

/** Anzeige von Informationen zu einer Kundennummer.
 *
 * Vor allem für die rechte Sidebar gedacht
 * */
export function GruppenCard(props: GruppenCardProps) {
  const [result] = useQuery({
    query: GRUPPEN_QUERY,
    variables: { nr: props.nr },
  })
  const { data, fetching, error } = result
  const gruppe = data?.entity
  const sx = { fontSize: 12 }

  if (!props.nr) {
    return null
  }

  return (
    <LadeChecker loading={fetching} error={error} data={gruppe} label={`Lade Gruppe`}>
      <Card sx={{ minWidth: '14em' }}>
        <CardContent>
          <section title="Gruppen Info" className="gruppeninfo">
            <Typography sx={sx}>
              <Typography color="text.secondary" gutterBottom>
                Gruppe
              </Typography>
              <div>
                <Typography>{gruppe?.name}</Typography> (<LinkRender value={gruppe?.designator} />)
              </div>

              <dl>
                {gruppe?.vertreter ? (
                  <>
                    <dt>
                      <Typography sx={sx} color="text.secondary">
                        Vertreter
                      </Typography>
                    </dt>
                    <dd>{gruppe?.vertreter}</dd>
                  </>
                ) : null}
                {gruppe?.branche ? (
                  <>
                    <dt>
                      <Typography sx={sx} color="text.secondary">
                        Branche
                      </Typography>
                    </dt>
                    <dd>{gruppe?.branche}</dd>
                  </>
                ) : null}
              </dl>
            </Typography>
          </section>
        </CardContent>
      </Card>
    </LadeChecker>
  )
}
export const GRUPPEN_QUERY = gql`
  query GruppenCard($nr: ID!) {
    entity: hwKundenGruppe(designator: $nr) {
      ...gruppeFragment
    }
  }
  ${GRUPPE_FRAGMENT}
`
